export const getCatalogColorById = (catalogColors, itemId) => {
  if (itemId === null || itemId === undefined) {
    return undefined;
  }

  return catalogColors[itemId];
};
